import { render, staticRenderFns } from "./TrialNotificationBubble.vue?vue&type=template&id=1ff58503&"
import script from "./TrialNotificationBubble.vue?vue&type=script&lang=js&"
export * from "./TrialNotificationBubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
